import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";

import { Figure } from "components/docs/Figure";
import { Color, magma, dmax, dmin } from "../../../styles/magma/_variables";
import * as styles from "./styles.module.scss";

const FlowDiagram = ({
  children,
  title,
  iconName = "Sitemap",
  showIcon = true,
  className,
  ...other
}) => {
  const baseColor = magma.pop06;
  const titleBgColor = Color.mix(baseColor, magma.neutral02, 50);
  // const stageBgColor = Color.mix(baseColor, dmax, 55);
  const iconColor = Color.mix(baseColor, dmin, 25).saturate(25);

  return (
    <Figure
      {...other}
      style={{
        "--icon-color": iconColor,
        // "--stage-bgcolor": stageBgColor,
        "--title-bgcolor": titleBgColor,
      }}
      subject={children}
      title={title}
      figureTypeName={"Flow Diagram"}
      iconName={iconName}
      showIcon={showIcon}
      className={classNames(styles.FlowDiagram, "FlowDiagram", className)}
    />
  );
};

export { FlowDiagram };
